export default __webpack_public_path__ + "static/media/P946_CoC.5dbbf42e.pdf";